import axios from 'axios'
import { apiURL } from '@/config'
import _ from 'lodash'

const constants = {
  namespaced: true,
  state: {
    endereco_uf: [],
    endereco_tipo: [],
    imovel_tipo: [],
    taxa_situacao: [],
    tarefa_tipo: []
  },
  mutations: {
    SET_CONSTANTS (state, payload) {
      for (let key in state) {
        state[key] = payload[key]
      }
    }
  },
  actions: {
    loadConstants ({ state, commit, dispatch }, payload) {
      axios.get(`${apiURL}/constants`).then((response) => {
        commit('SET_CONSTANTS', response.data)
      }, (error) => {
        if (error.response.status === 401) {
          dispatch('utils/showSnackbar', {
            text: 'Realize o login novamente.'
          }, { root: true })
        } else {
          dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.',
            persistent: true
          }, { root: true })
        }
      })
    }
  },
  getters: {
    enderecoUF (state) {
      return _.map(state.endereco_uf, (key, value) => {
        return { text: key['titulo'], value: key['uf'] }
      })
    },
    enderecoTipo (state) {
      return _.map(state.endereco_tipo, (key) => {
        return { text: key, value: key }
      })
    },
    imovelTipo (state) {
      return state.imovel_tipo
    },
    taxaSituacao (state) {
      return state.taxa_situacao
    },
    tarefaTipo (state) {
      return state.tarefa_tipo
    }
  }
}

export default constants



// WEBPACK FOOTER //
// ./src/vuex/modules/constants.js